const QUESTION_ANSWER_SLIDE_COMPONENT = 'QuestionAnswerSlide';
const QUESTION_MULTI_ANSWER_SLIDE_COMPONENT = 'QuestionMultiAnswerSlide';
const PROFILE_SLIDE_COMPONENT = 'ProfileSlide';
const START_SLIDE = 'StartSlide';
const TRUST_SLIDE = 'TrustSlide';
const USER_MIX_SUMMARY_SLIDE = 'UserMixSummary';
const PLAN_LOADER_SLIDE = 'PlanLoaderSlide';
const EMAIL_SLIDE = 'EmailSlide';
const RISK_SLIDE = 'RiskSlide';

export {
    QUESTION_ANSWER_SLIDE_COMPONENT,
    QUESTION_MULTI_ANSWER_SLIDE_COMPONENT,
    PROFILE_SLIDE_COMPONENT,
    START_SLIDE,
    TRUST_SLIDE,
    PLAN_LOADER_SLIDE,
    EMAIL_SLIDE,
    USER_MIX_SUMMARY_SLIDE,
    RISK_SLIDE
};
